<template>
  <el-table class="table-striped"
            v-loading="loading"
            ref="elTable"
            :data="value">
    <el-table-column max-width="120" :label="'User/Invitation' | translate">
      <template slot-scope="props">
        <div v-if="props.row.user !== null">
          <strong>{{props.row.user.fullName || props.row.user.username}}</strong><br/>
          <small><translate>User:</translate> {{ props.row.user.email }}</small>
        </div>
        <div v-else-if="props.row.invite.fullName">
          <strong>{{props.row.invite.fullName}}</strong><br/>
          <small><translate>Invite:</translate> {{ props.row.invite.email }}</small>
        </div>
        <div v-else>
          <strong>{{ props.row.invite.email }}</strong><br/>
          <small><translate>Invite</translate></small>
        </div>
      </template>
    </el-table-column>
    <el-table-column max-width="120" :label="'Role' | translate">
      <template slot-scope="props">
        <el-select v-model="props.row.role"
                   class="select-success">
          <el-option v-for="item in $data.roleTypes" :label="item.displayName"
                     :value="item.value" :key="item.value"></el-option>
        </el-select>
      </template>
    </el-table-column>
    <el-table-column
      class-name="action-buttons td-actions"
      align="right"
      :label="'Actions' | translate">
      <template slot-scope="props">
        <el-tooltip :content="'Send invite again' | translate" placement="top"
                    v-if="props.row.id && props.row.invite !== null">
          <p-button type="success" size="sm" icon @click="(e) => handleSendAgain(e, props.$index, props.row)">
            <i class="fa fa-envelope"></i>
          </p-button>
        </el-tooltip>
        <el-tooltip :content="'Delete' | translate" placement="top">
          <p-button type="danger" size="sm" icon
                    @click="(e) => handleDelete(e, props.$index, props.row)">
            <i class="fa fa-times"></i>
          </p-button>
        </el-tooltip>
      </template>
    </el-table-column>
    <template slot="append">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <el-select filterable
                       v-model="append"
                       class="select-success"
                       :placeholder="'Add user or invite' | translate"
                       reserve-keyword
                       allow-create
                       default-first-option
                       @change="appendSelected"
                       remote :remote-method="appendSearch">
              <el-option-group
                v-for="(group, title) in appendSelect"
                :key="title"
                v-if="group.length > 0"
                :label="recordTypes[title]">
                <el-option
                  v-for="item in group"
                  :key="item.id"
                  :label="item.type === 'user' ? `${item.fullName || item.username}`: `${item.fullName}`"
                  :value="item">
                  <span style="float: left" v-if="item.type === 'user'">{{ item.fullName || item.username }}</span>
                  <span style="float: left" v-else>{{ item.fullName }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.email }}</span>
                </el-option>
              </el-option-group>
            </el-select>
          </div>
        </div>
        <modal :show.sync="modalForm.show" v-if="modalForm.show">
          <edit-form v-model="modalForm" is-modal @on-invitation="appendSelected"
                     :source="source"
                     v-on="$listeners"></edit-form>
        </modal>
      </div>
    </template>
  </el-table>
</template>

<script>
  import {Table, TableColumn, Select, OptionGroup, Option, Tooltip} from 'element-ui'
  import {Modal} from 'src/components/UIComponents'
  import EditForm from '../Admin/InvitationForm'
  import swal from 'sweetalert2'


  export default {
    props: {
      value: {
        type: !Array
      },
      source: !Object
      // type
    },
    created () {
      this.loadRoleTypes()
      this.appendSearch('')
    },
    components: {
      Modal, EditForm,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Tooltip.name]: Tooltip,
      [Select.name]: Select,
      [OptionGroup.name]: OptionGroup,
      [Option.name]: Option,
    },
    data () {
      return {
        loading: false,
        modalForm: {
          show: false,
          modelId: null
        },
        recordTypes: {
          user: this.$gettext("User"),
          invitation: this.$gettext("Invitation")
        },
        roleTypes: [],
        append: null,
        appendSelect: []
      }
    },
    name: 'PermissionsTable',
    methods: {
      async loadRoleTypes() {
        const response = await this.$http.options('stands/permission/')
        this.roleTypes = response.data.actions.POST.role.choices
      },
      onInvitation (info) {
        debugger
      },
      appendSelected (item) {
        if (typeof item === 'string') {
          this.modalForm.model = {
            id: null,
            lastName: null,
            firstName: null,
            secondName: null,
            email: item,
            language: 'ru'
          }
          this.modalForm.show = true
        } else {
          const element = {
            id: null,
            invite: null,
            role: this.roleTypes[0].value,
            stand: parseInt(this.$route.params.standId),
            user: null
          }
          if (item.type === 'user') {
            element.user = item
          } else {
            element.invite = item
          }
          this.value.push(element)
        }
        this.append = null
      },
      handleDelete(e, $index, row) {
        this.value.splice(this.value.indexOf(row), 1)
        // this.value = this.value.filter(e => e !== row)
      },
      async handleSendAgain(e, $index, row) {
        this.loading = true
        try {
          await this.$http.post(`invitation/${row.invite.id}/send/`)
          let message = this.$gettext('<span>Invite to <strong>%{email}</strong> successfully sent.</span>')
          this.loading = false
          swal({
            title: this.$gettext('Successful'),
            html: this.$gettextInterpolate(message, {email: row.invite.email}),
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          })
        } catch (e) {
          let message = this.$gettext('<span>Invite to <strong>%{email}</strong> not sent.</span>')
          this.loading = false
          swal({
            title: this.$gettext('Error'),
            html: this.$gettextInterpolate(message, {email: row.email}),
            type: 'error',
            confirmButtonClass: 'btn btn-warning btn-fill',
            buttonsStyling: false
          })
        }
        // this.value.splice(this.value.indexOf(row), 1)
        // this.value = this.value.filter(e => e !== row)
      },
      async appendSearch (query) {
        const users = await this.$http.get('user/', {params: {search: query}})
        const invitations = await this.$http.get('invitation/', {params: {search: query}})
        users.data.map(e => e.type = 'user')
        invitations.data.map(e => e.type = 'invitation')
        this.appendSelect = {
          user: users.data,
          invitation: invitations.data
        }
      },

    }
  }
</script>

<style scoped>
  .modal-body {
    padding: 0;
  }
</style>
